import { createContext, useContext, useState, type PropsWithChildren } from 'react';

const defaultConfig = {
  installments_payment: false, // No se usa en el proyecto
  reviews: false,
  reviews_lang:
    'es_ES,en_ES,ca_ES,de_DE,en_DE,it_IT,en_IT,en_GB,fr_FR,en_FR,en_US,es_US,en_JP,ja_JP,en_TR,tr_TR,en_AT,de_AT,en_PL,pl_PL,en_BE,de_BE,fr_BE,nl_BE,en_GR,el_GR,en_AU,en_CH,de_CH,fr_CH,it_CH,en_MX,es_MX,en_NL,nl_NL,en_KR,ko_KR,en_IE,pt_PT,en_PT',
  specific_taxes: false, // No se usa en el proyecto
  market_by_region: false, // No se usa en el proyecto
  ia_recommendations: false, // No se usa en el proyecto
  size_label: false, // No se usa en el proyecto
  allow_single_char_names: false, // No se usa en el proyecto
  take_back: false, // Se usa en 1 lugar
  voucher_pre_takeback: false, // No se usa en el proyecto
  gift_card: false, // Se usa en 1 lugar
  allow_special_chars: false, // No se usa en el proyecto
  cookiebot: false, // Se usa en 1 lugar
  show_free_shipping: false,
  show_gift_purchase: false,
  sku_gift_purchase: '',
  image_search: false, // Se usa en 1 lugar
  unbxd: false, // No se usa en el proyecto
  globale_fixed_price: false, // Se usa en 1 lugar
  hide_telephone_numbers: false, // Se usa en 1 lugar
  captchaEnabled: false,
  captchaMinimumValue: 0.3, // No se usa en el proyecto
  instantFAQ: false, // No se usa en el proyecto
  instantFAQ_subreason_ids: {} as Record<string, number>, // No se usa en el proyecto
  gratis_cambio_talla: false, // No se usa en el proyecto
  checkout_address_autocomplete: false, // Se usa en 1 lugar
  cj_cid: '', // No se usa en el proyecto
  cj_type: '', // No se usa en el proyecto
  collectionEmptyBag: {
    // No se usa en el proyecto
    W: '',
    M: '',
    K: '',
    A: '',
  },
  squareImage: false,
  fake_free_shipping: false,
  fetch_colors: false, // Se usa en 1 lugar
  additional_delivery_info: false,
  cms_fallback: false, // No se usa en el proyecto
};

export type CountryConfig = typeof defaultConfig;

type FeaturesContextType = {
  config: CountryConfig;
};

const FeaturesContext = createContext<FeaturesContextType | undefined>(undefined);

export function FeatureFlagsProvider({ children, initialConfig }: PropsWithChildren<{ initialConfig: CountryConfig }>) {
  const [config] = useState<CountryConfig>(() => initialConfig ?? defaultConfig);

  return <FeaturesContext.Provider value={{ config }}>{children}</FeaturesContext.Provider>;
}

// Hook tipado genéricamente para devolver el tipo del flag solicitado
export function useFeature<K extends keyof CountryConfig>(name: K): CountryConfig[K] {
  const context = useContext(FeaturesContext);
  if (context === undefined) {
    throw new Error('useFeatures must be used within a FeaturesProvider');
  }

  const value = context.config[name];
  if (value === undefined) {
    return defaultConfig[name];
  }
  return value;
}
